﻿import { CommonRouteFunctionService } from './../../services/common-routing-service';
import { CommonService } from 'app/services/common.service';
import { LoggedService } from './../../services/logged.service';
import { CommonAuthenticationService } from './../../services/common-authentication.service';
import { RouteDataService } from './../../services/route-data.service';
import { Component, OnInit, Renderer2 } from '@angular/core';
import { LoginInfoProvider } from '../../ev-dal/login-info.provider';
import { LoginService } from '../../services/login.service';
import { DraggableModalService } from '../shared/draggable-modal/draggable-modal.service';
import { CommonDataSharedService } from 'app/services';

@Component({
  selector: 'app-main-nav',
  templateUrl: './main-nav.component.html',
  styleUrls: ['./main-nav.component.scss']
})
export class MainNavComponent implements OnInit {
  userData: any;
  partnerData;

  constructor(
    private loginInfoProvider: LoginInfoProvider,
    private loginService: LoginService,
    private _routeDataService: RouteDataService,
    private _commonAuthService: CommonAuthenticationService,
    private ls: LoggedService,
    private _commonService: CommonService,
    private _commonRouteFunctionService: CommonRouteFunctionService,
    private draggableModalService: DraggableModalService,
    private renderer: Renderer2,
    private _commonDataSharedService: CommonDataSharedService
  ) { }

  ngOnInit() {
    this.partnerData = this.loginInfoProvider.parnerDetailData;
    this.userData = this.loginInfoProvider.loginInfo;

    this._commonDataSharedService.avatarUpdate.subscribe(data => {
      this.userData.fileUrl = data;
      const localStorageData = JSON.parse(localStorage.getItem('loginUserData'));
      localStorageData['fileUrl'] = data;
      localStorage.setItem('loginUserData', JSON.stringify(localStorageData));
     // window.location.reload();
    });

    this._commonRouteFunctionService.breadCrumb.subscribe((data: string) => {
      this._commonService.setDataWithoutObservable(data, 'breadCrumbData');
    });

    this.ls.getLogged().subscribe(() => {
      this.userData = this.loginInfoProvider.loginInfo;
    });

    this._routeDataService.login.subscribe(() => {
      this.userData = this._commonAuthService.getLoginData();
    })
  }

  accountSettingsClicked() {
    this.draggableModalService.show({
      id: 'account-settings-modal',
      initialState: {
        username: this.userData.email,
        avatarUrl: this.userData.avatarURL
      }
    });
  }

  logout() {
    this.loginService.logout();
    this.renderer.removeClass(document.body, 'menu-open');
  }
}
